import { Component, OnDestroy, OnInit } from '@angular/core';
import { PrintService } from './shared/services/print/print.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CookieConsentComponent } from './components/cookie-consent/cookie-consent.component';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private routerSubscription!: Subscription;
  private cookieConsentDialogRef: MatDialogRef<CookieConsentComponent> | null =
    null;

  constructor(
    public printService: PrintService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    const cookieConsent = localStorage.getItem('cookieConsent');
    const currentUrl = this.router.url;

    if (!cookieConsent && currentUrl !== '/privacy-policy') {
      this.openCookieConsentDialog();
    }

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/privacy-policy' && this.cookieConsentDialogRef) {
          this.cookieConsentDialogRef.close();
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  openCookieConsentDialog(): void {
    this.cookieConsentDialogRef = this.dialog.open(CookieConsentComponent, {
      disableClose: true,
      panelClass: 'custom-dialog-container',
    });
  }
}
